import API from "../api";
import { apiCallbackTreatment } from "../auxiliary/generalFunctions";

const api = new API();

export default class CommissionRulesDetailsIntervalsController
{
    async create(data) 
    {
        const response = await api.commissionRulesDetailsIntervals().post(data);
        return apiCallbackTreatment(response);
    }

    async deleteById(id)
    {
        const response = await api.commissionRulesDetailsIntervals().remove(id);
        return apiCallbackTreatment(response);
    }

    async update(id, data) {
        const response = await api.commissionRulesDetailsIntervals().update(id, data);
        return apiCallbackTreatment(response);
    }
}